import { asMessages } from '@core/Utils/Intl/AsMessages';

export const scope = 'containers.component.offerModal';

const definition = asMessages(scope, {
  campaignLayoutOne: '2 offers',
  campaignLayoutOneTwo: ' apply on this car when you buy online.',
  findMore: ' Find out more',
  findMoreMobile: ' View more',
  campaignDelivery: 'offers apply. Delivery is free.',
  campaignTitle: 'Our latest offers',
} as const);

export const offerModalMessages = definition.messages;
export const defaultOfferModalMessages = definition.defaultMessages;
export type OfferModalMessages = typeof definition.defaultMessages;
